import { useCallback } from 'react';
import { useTemplateEditorDispatch } from '../context/UseTemplateEditorContext';

export const useDiscardChanges = () => {
  const dispatch = useTemplateEditorDispatch();
  return useCallback(() => {
    dispatch({
      type: 'DISCARD_CHANGES',
    });
  }, [dispatch]);
};
